// extracted by mini-css-extract-plugin
module.exports = {"signupDescription":"SignUp_signupDescription__AUXxw","haveAnAccountSig":"SignUp_haveAnAccountSig__SiwWe","signupList":"SignUp_signupList__er41q"};